/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountCustomerTypeQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountCustomerTypeQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly customerType: GraphQL.CustomerType | null } | null };


export const AccountCustomerTypeDocument = gql`
    query AccountCustomerType($accountId: AccountId!) {
  account(id: $accountId) {
    id
    customerType
  }
}
    `;

/**
 * __useAccountCustomerTypeQuery__
 *
 * To run a query within a React component, call `useAccountCustomerTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountCustomerTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountCustomerTypeQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountCustomerTypeQuery(baseOptions: Apollo.QueryHookOptions<AccountCustomerTypeQuery, AccountCustomerTypeQueryVariables> & ({ variables: AccountCustomerTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountCustomerTypeQuery, AccountCustomerTypeQueryVariables>(AccountCustomerTypeDocument, options);
      }
export function useAccountCustomerTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountCustomerTypeQuery, AccountCustomerTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountCustomerTypeQuery, AccountCustomerTypeQueryVariables>(AccountCustomerTypeDocument, options);
        }
export function useAccountCustomerTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountCustomerTypeQuery, AccountCustomerTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountCustomerTypeQuery, AccountCustomerTypeQueryVariables>(AccountCustomerTypeDocument, options);
        }
export type AccountCustomerTypeQueryHookResult = ReturnType<typeof useAccountCustomerTypeQuery>;
export type AccountCustomerTypeLazyQueryHookResult = ReturnType<typeof useAccountCustomerTypeLazyQuery>;
export type AccountCustomerTypeSuspenseQueryHookResult = ReturnType<typeof useAccountCustomerTypeSuspenseQuery>;
export type AccountCustomerTypeQueryResult = Apollo.QueryResult<AccountCustomerTypeQuery, AccountCustomerTypeQueryVariables>;